module.exports = __webpack_public_path__ + "img/el-phone-yc.svg";